import axios from 'axios';
import type { DownloadMonthPaymentDetailParams } from '@/types/api/finance/downloadMonthPaymentDetail';
import type { GetBillPDFParams } from '@/types/api/finance/getBillPDF';
import type {
  IncomeStatementFormValues,
  MonthlyBillsFormValues,
} from './types';

type DownloadBlobFn<T> = (values: T) => Promise<Blob>;

const getIncomeStatementFile: DownloadBlobFn<
  IncomeStatementFormValues
> = async (values) => {
  const params: DownloadMonthPaymentDetailParams = {
    timeStart: values.timeStart.valueOf(),
  };
  const result = (
    await axios.get<Blob>('/ezcon/api/downloadMonthPaymentDetail', {
      headers: {
        authorization: localStorage.getItem('feathers-jwt'),
      },
      params,
      responseType: 'blob',
    })
  ).data;
  return result;
};

const getMonthlyBillsFile: DownloadBlobFn<MonthlyBillsFormValues> = async (
  values
) => {
  const params: GetBillPDFParams = {
    timeStart: values.timeStart.valueOf(),
    isFilterPaid: values.isFilterPaid || true,
    householdNumber: null,
  };
  console.log(params);
  const result = (
    await axios.get<Blob>('/ezcon/api/getBillPDF', {
      headers: {
        authorization: localStorage.getItem('feathers-jwt'),
      },
      params,
      responseType: 'blob',
    })
  ).data;
  return result;
};

const getUnpaidBillsFile: DownloadBlobFn<never> = async () => {
  const result = (
    await axios.get<Blob>('/ezcon/api/unpaidExcel', {
      headers: {
        authorization: localStorage.getItem('feathers-jwt'),
      },
      responseType: 'blob',
    })
  ).data;
  return result;
};

export { getIncomeStatementFile, getMonthlyBillsFile, getUnpaidBillsFile };
export type { DownloadBlobFn };
